/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
// import AddToHomescreen from 'react-add-to-homescreen';
import { Component, Fragment } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Notification, { notify } from 'react-notify-toast';
import { ScrollToTop } from 'Components';
import './App.scss';
import { Http, API, Utils, Auth, Constant, _ } from "Helpers";
import { Layout } from "Pages";
import { ReduxHOC } from "HOC";
import { SessionStorage, setGameId } from "Helpers/Utilieties";
import history from "./history";
const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      AppInit: false,
      Cookies: undefined,
      layoutPosting:false
    }
  }
  componentDidMount() {
     if (Auth.getAuth() && Utils.getLangPosting()) {
      Http.post(API.UPDATE_LANG).then(response => {
        localStorage.removeItem('lang_posting');
      })
    }

    Utils.setCpSession()
    this.getSessionKey()

  }

      getSpotlight = async (spotlightStr) => {
         Http.get(`${API.GET_SPL}${btoa(spotlightStr)}`).then(response => {
          if(response.data){
            SessionStorage.set("spotlight_str", response.data)
          }
        })
    }

  getSessionKey = () => {
    
    if (!_.isUndefined(parsed) && !_.isEmpty(parsed)) {
        if(parsed && parsed.token && parsed.token.replace("\"", "") !== '' && parsed.token!=='401'){
         this.authenticate(parsed.token.replace("\"", ""))
        }else{
          // Remove query params from URL after processing
          this.setState({
          AppInit:true,
          layoutPosting:true
        })
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        }
        if(parsed.token=='401'){
          Auth.removeAuth();
        }
        if(parsed && parsed.spotlight){
         const spotlight = parsed.spotlight;
        if(spotlight && spotlight!=='null'){
          if(spotlight=='clear'){
            SessionStorage.remove()
          }else{
            const _spotlight = spotlight.replace(/_/g, ' ')
           this.getSpotlight(_spotlight);
          }
        }
      }
      if(parsed && parsed.game_id){
        console.log('game_id', parsed.game_id);
       setGameId(parsed.game_id);     
      }
      }else{
         this.setState({
          AppInit:true,
          layoutPosting:true
        })
      }
  }

  sendMessageToParent = (event) => {
    window.parent.postMessage({ action: event }, '*');
  };

  authenticate = (token) => {
    this.setState({ posting: true });


    let param = {
      "token":token,
      "device_type":"3"
    }
 
    Http.post(API.FANTASY_USER_PROFILE, param).then(response => {

      
      if(Auth.getAuth() === response.data.Sessionkey ){
        history.replace(window.location.pathname)
        this.setState({
          AppInit:true,
          layoutPosting:true
        })
      }
      else{
      if(response.response_code == 200){
        Auth.setAuth(response.data.Sessionkey);
        Utils.setProfile(response.data);
      this.setState({
        AppInit:true,
        layoutPosting:true
      },()=>{
        Auth.setAuth(response.data.Sessionkey);
        Utils.setProfile(response.data);
      //  window.location.reload(false);
        history.replace(window.location.pathname)
      })

      if (window.ReactNativeWebView) {
        let data = {
          action: "login",
          type: 'login',
          targetFunc: "loginFunc",
          userData: response.data
        };
        this.sendMessageToApp(data);
      }
    }
  }
    }).catch(error => {
      this.sendMessageToParent('CLICKED_BACK_BUTTON')
      if (error.data) {

        //window.open(error.data.redirection, "_self")
      }
      this.setState({ posting: false });
      // if(!isGuestUser) {
      // }

    });
  }
 
  render() {
    const {AppInit, layoutPosting} = this.state
    return (
    //  AppInit ?
              <Fragment>
                <Notification options={{ zIndex: 99999 }} />
                <BrowserRouter>
                  <ScrollToTop>
                    {layoutPosting && 
                    <Switch>
                      <Route exact component={Layout} />
                      <Redirect from="*" to={Constant.DEFAULT_ROOT} />
                    </Switch>
                    }
                  </ScrollToTop>
                </BrowserRouter>
              </Fragment>
              //  : ''
    );
  }
}

export default ReduxHOC(App);